"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator")),
    _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator")),
    _react = _interopRequireDefault(require("react")),
    _uiKit = require("@devsta/ui-kit"),
    _onEnterPressed = _interopRequireDefault(require("@devsta/on-enter-pressed")),
    _classnames = _interopRequireDefault(require("classnames")),
    _lodash = _interopRequireDefault(require("lodash.memoize")),
    _ContentLoader = _interopRequireDefault(require("../../../../ContentLoader")),
    _utils = require("../../../utils"),
    _Replies = _interopRequireDefault(require("../../../common/Replies"));

require("../styles/_comment.scss");

var _CommentBody = _interopRequireDefault(require("./CommentBody")),
    _CommentFooter = _interopRequireDefault(require("./CommentFooter")),
    onUpdateCheckbox = (0, _lodash["default"])(function (a) {
  var b = a.commentId,
      c = a.isResolved,
      d = a.updateComment;
  return function (a) {
    a.stopPropagation(), d(b, {
      isResolved: !c
    });
  };
}),
    handleDelete = (0, _lodash["default"])(function (a) {
  var b = a.commentId,
      c = a.deleteComment;
  return function () {
    var a = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function a(d) {
      return _regenerator["default"].wrap(function (a) {
        for (;;) {
          switch (a.prev = a.next) {
            case 0:
              d.stopPropagation(), c({
                commentId: b
              });

            case 2:
            case "end":
              return a.stop();
          }
        }
      }, a);
    }));
    return function () {
      return a.apply(this, arguments);
    };
  }();
});

function CommentComponent(a) {
  var b = a.commentIndex,
      c = a.comment,
      d = a.comment,
      e = d.commentId,
      f = d.content,
      g = d.createdByUser,
      h = d.updatedAt,
      i = d.children,
      j = void 0 === i ? [] : i,
      k = d.isResolved,
      l = d.fetching,
      m = d.assetIds,
      n = a.canResolveComment,
      o = a.getUserColor,
      p = a.updateComment,
      q = a.getCommentTitle,
      r = a.isGroupSelected,
      s = a.isCommentSelected,
      t = a.onSelectComment,
      u = a.deleteComment;
  if (l) return _react["default"].createElement("div", {
    className: "comment"
  }, _react["default"].createElement(_ContentLoader["default"], {
    darkTheme: !0
  }, _react["default"].createElement("rect", {
    x: "0",
    y: "10",
    rx: "4",
    ry: "4",
    width: "400",
    height: "15"
  }), _react["default"].createElement("rect", {
    x: "0",
    y: "50",
    rx: "3",
    ry: "3",
    width: "400",
    height: "12"
  }), _react["default"].createElement("rect", {
    x: "0",
    y: "73",
    rx: "3",
    ry: "3",
    width: "400",
    height: "12"
  }), _react["default"].createElement("rect", {
    x: "0",
    y: "100",
    rx: "15",
    ry: "15",
    width: "32",
    height: "32"
  }), _react["default"].createElement("rect", {
    x: "40",
    y: "110",
    rx: "3",
    ry: "3",
    width: "360",
    height: "12"
  })));
  var v = (0, _utils.getUser)(g),
      w = o({
    userId: v.userId
  }),
      x = w.color,
      y = w.brightness;
  return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement("div", {
    role: "button",
    onClick: t,
    onKeyPress: (0, _onEnterPressed["default"])({
      onClick: t
    }),
    tabIndex: b,
    className: (0, _classnames["default"])("comment", {
      "comment--group-selected": r
    }, {
      "comment--comment-selected": s
    })
  }, _react["default"].createElement("div", {
    className: "comment__upper-container"
  }, _react["default"].createElement("div", {
    className: "comment__upper-container__heading"
  }, _react["default"].createElement("div", {
    className: "comment__upper-container__heading__left"
  }, _react["default"].createElement("div", {
    className: "comment__upper-container__heading__left__number",
    style: {
      backgroundColor: x,
      filter: y
    }
  }, _react["default"].createElement(_uiKit.Text, {
    button: !0,
    darkTheme: !0,
    noMargin: !0
  }, b + 1)), _react["default"].createElement(_uiKit.Text, {
    heading4: !0,
    noMargin: !0,
    className: "comment__upper-container__heading__left__title"
  }, q && q(c))), m.length ? _react["default"].createElement("div", {
    className: "comment__upper-container__heading__right__attachments"
  }, _react["default"].createElement(_uiKit.Text, {
    noMargin: !0,
    label: !0
  }, m.length), _react["default"].createElement(_uiKit.Icon, {
    name: "attachment",
    size: 15
  })) : null, n ? _react["default"].createElement(_uiKit.Checkbox, {
    checked: k,
    onChange: onUpdateCheckbox({
      commentId: e,
      isResolved: k,
      updateComment: p
    })
  }) : null), _react["default"].createElement(_CommentBody["default"], {
    content: f
  })), _react["default"].createElement(_CommentFooter["default"], {
    user: (0, _utils.getUser)(g),
    updatedAt: h,
    handleDelete: handleDelete({
      commentId: e,
      deleteComment: u
    })
  })), _react["default"].createElement(_Replies["default"], {
    replies: j,
    handleDelete: handleDelete,
    deleteComment: u
  }));
}

var _default = CommentComponent;
exports["default"] = _default;